module.exports = __webpack_public_path__ + "static/media/lease2_img10.2a2571fb.jpg";